import type { MeetingAttributionJobsResponse } from '@/api/internal'

export const selectAttributionJob = (
  response: MeetingAttributionJobsResponse | undefined,
  requestedJobId: string | null
) => {
  const jobs = response?.jobs ?? []
  const selectedJob =
    jobs.find((job) => job.job_id === requestedJobId && job.viewable) ?? jobs.find((job) => job.viewable) ?? null
  const displayedJobId = response?.displayed_job_id ?? null
  return {
    selectedJob,
    apiJobId: selectedJob && selectedJob.job_id !== displayedJobId ? selectedJob.job_id : null,
  }
}
